import { UGC_API } from '../../utils/constants';

async function fetchUgcData(filter = '', after = '', requireProduct = true) {
  const optParams = {
    filter,
    after,
    requireProduct,
  };
  const ugcSrc = `${UGC_API}?${new URLSearchParams(optParams)}`;
  return fetch(ugcSrc, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export default fetchUgcData;
